import { IQueryCond, IQueryOrder } from './../interfaces/query.interface';
export class Query {
  id: number;
  table_name: string;
  table_label: string;
  query_name: string;
  dataset: string;
  asset_query_cond: IQueryCond[];
  asset_query_ord: IQueryOrder[];
  query_script: string;
  context_id: string;
  user_id: string;
  date_modified: string;
  date_created: string;

  public constructor(init?: Partial<Query>) {
    Object.assign(this, init);
  }

  orderPositionCond() {
    this.asset_query_cond.forEach(function (value, i) {
      value.position = i;
    });
  }

  orderPositionQuery() {
    this.asset_query_ord.forEach(function (value, i) {
      value.position = i;
    });
  }

  emptyAssetQuery() {
    this.asset_query_cond = [];
    this.asset_query_ord = [];
  }
}
